import React from "react";

import "../assets/styles/containerStyles/footer.scss";
import { ForStepsLogo } from "../assets/images";

export function Footer(props) {


    return <div className={`implementation ${props.leftSideMenuOpen ? "show" : ""}`}>
        <div className={'inner'}>
            <span>Իրագործումը՝ </span>
            <a href="https://4steps.am">
                <ForStepsLogo/>
            </a>
        </div>
    </div>
}
